module.exports = __webpack_public_path__ + "static/undirected-graph-loop-9479322ae61f1396b17b1db6742f3e5f.svg";